import React from "react";

// YOUTUBE
import YouTube from 'react-youtube'

// STYLES
import styled from "styled-components";

// COMPONENTS
import Modal from 'react-responsive-modal';

export default class ReceiptVideo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isPlaying:false, isOpen:false}
    }

    render() {
        //let videoIdUrl = []
        //let videoIdUrlStart = []
        
       /* if(this.props.videoUrl.includes("v=")){
            videoIdUrl = this.props.videoUrl.split("v=")
            videoIdUrlStart = videoIdUrl[1].split("&")
        }*/

        const _onPlay = event => {
            event.target.pauseVideo();
            this.setState({ isOpen: true })
        }

        const _onReady = event => {
            event.target.playVideo()
        }
        
        return (
            <VideoThumbnail>
                {
                    this.state.isOpen && 
                        <Modal styles={Modalstyles} open={this.state.isOpen} onClose={() => this.setState({isOpen:false})} center>
                            <YouTube
                                videoId={this.props.videoUrl}
                                opts={optsModal}
                                onReady={_onReady}
                            />
                        </Modal>
                }
                <YouTube
                    videoId={this.props.videoUrl}
                    opts={opts}
                    onPlay={_onPlay}
                />
            </VideoThumbnail>
        )
    }   
}

const opts = {
    width: '100%',
    origin:'http://localhost:3001',
    height: '250px'
}

const optsModal = {
    width:'100%',
    origin:'http://localhost:3001'
}

const Modalstyles = {
    modal:{
        width:'100%',
        justifyContent:'center',
        padding:'30px',
        marginTop:'10%',
        borderRadius:'2px',
    },
    closeIcon:{
        top: 3,
        right: 3,
    },
}

const VideoThumbnail = styled.div`
    width: 100%;
    padding-top:35px;
`


// WEBPACK FOOTER //
// ./src/components/receiptVideo/receiptvideo.component.js